import React from "react";

const ArticleReferences = () => {
  return (
    <div>
      <div className="mb-20">
        <h2 id="References" className="mt-20">
          References
        </h2>
        <ul>
          <ol type="1">
            <li id="reference1">
              Stockholm Resilience Centre <br />
              <a href="https://www.stockholmresilience.org/research/research-news/2016-06-14-the-sdgs-wedding-cake.html">
                The SDGs wedding cake
              </a>
            </li>

            <li id="reference2">
              Terry L. Roberts <br />
              <a href="https://www.sciencedirect.com/science/article/pii/S1877705814011059">
                Cadmium and Phosphorous Fertilizers: The Issues and the Science
              </a>
            </li>

            <li id="reference3">
              Florian Bornes <br />
              <a href="https://dumas.ccsd.cnrs.fr/dumas-03474877/document">
                Évaluation des probiotiques sur le marché oﬀicinal et
                élaboration d’un guide pratique d’aide au conseil sur les
                probiotiques pour le pharmacien d’oﬀicine. Sciences du Vivant
                [q-bio]. 2020.dumas-03474877e
              </a>
            </li>
          </ol>
        </ul>
      </div>
    </div>
  );
};

export default ArticleReferences;
